define(["require", "exports", "knockout", "UI/Templates"], function (require, exports, ko, Templates_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.Modal = exports.ConfirmationType = void 0;
    var ConfirmationType;
    (function (ConfirmationType) {
        ConfirmationType[ConfirmationType["Success"] = 0] = "Success";
        ConfirmationType[ConfirmationType["Warning"] = 1] = "Warning";
        ConfirmationType[ConfirmationType["Error"] = 2] = "Error";
    })(ConfirmationType = exports.ConfirmationType || (exports.ConfirmationType = {}));
    class Modal {
        constructor(data) {
            var _a;
            this.Close = () => {
                if (this.IsOpen())
                    $("#" + this.Id).modal("hide");
            };
            this.Open = () => {
                if (this.IsOpen())
                    return;
                this.IsOpen(true);
                if (!this.Initialized() || this.DestroyOnClose()) {
                    this.Initialize().then(() => this.Modal.modal('show'));
                }
                else {
                    this.Modal.modal('show');
                }
            };
            this.OpenHidden = () => {
                if (!this.Initialized()) {
                    this.Initialize();
                }
                return this;
            };
            this.Initialize = () => {
                if ($("#modal-" + this.Id)[0] == null)
                    $("body").append($("<div/>").attr("id", "modal-" + this.Id));
                return Templates_1.default.LoadTemplate("/areas/cms/templates/modal.html")
                    .done(() => {
                    var html = $("<div/>").attr("data-bind", "loadTemplate: { name: '/areas/cms/templates/modal.html', data: $data }");
                    $("#modal-" + this.Id).html(html);
                    ko.applyBindings(this, document.getElementById("modal-" + this.Id));
                    var modal = $("#" + this.Id)
                        .on("show.bs.modal", () => {
                        if (this.OnShow() != null)
                            this.OnShow()();
                    })
                        .on("shown.bs.modal", event => {
                        $(event.target).find(":input:not(:button):first").focus();
                        if (this.OnShown() != null)
                            this.OnShown()();
                    })
                        .on("hide.bs.modal", () => {
                        this.IsOpen(false);
                        if (this.OnHide() != null)
                            this.OnHide()();
                    })
                        .on("hidden.bs.modal", () => {
                        if (this.OnHidden() != null)
                            this.OnHidden()();
                        $("#Modal").find(".modal")
                            .off("show.bs.modal")
                            .off("shown.bs.modal")
                            .off("hide.bs.modal")
                            .off("hidden.bs.modal");
                        if (this.DestroyOnClose()) {
                            $("#modal-" + this.Id).remove();
                        }
                    });
                    this.Modal = modal;
                    this.Initialized(true);
                });
            };
            this.ConfigModal = (config) => {
                this.Modal.modal(config);
            };
            data = $.extend({}, {
                Title: null,
                BodyTemplates: null,
                Body: null,
                FooterTemplates: null,
                FooterButtons: null,
                ModalContainerClass: null,
                ModalCssClass: "modal-lg",
                OnShow: null,
                OnHide: null,
                OnShown: null,
                OnHidden: null,
                DestroyOnClose: true,
                InitializedHandler: () => { }
            }, data || {});
            (_a = data === null || data === void 0 ? void 0 : data.BodyTemplates) === null || _a === void 0 ? void 0 : _a.forEach((template) => {
                if (!template.Data) {
                    template.Data = this;
                }
            });
            this.Title = ko.observable(data.Title);
            this.Body = ko.observable(data.Body);
            this.BodyTemplates = ko.observableArray(data.BodyTemplates);
            this.FooterTemplates = ko.observableArray(data.FooterTemplates);
            this.FooterButtons = ko.observableArray(data.FooterButtons);
            this.ModalContainerCssClass = ko.observable(data.ModalContainerCssClass);
            this.ModalCssClass = ko.observable(data.ModalCssClass);
            this.OnShow = ko.observable(data.OnShow);
            this.OnHide = ko.observable(data.OnHide);
            this.OnShown = ko.observable(data.OnShown);
            this.OnHidden = ko.observable(data.OnHidden);
            this.IsOpen = ko.observable(false);
            this.DestroyOnClose = ko.observable(data.DestroyOnClose);
            this.AutoClose = ko.observable(false);
            this.Id = createGuid();
            this.Initialized = ko.observable(false);
            this.Initialized.subscribe(data.InitializedHandler);
            this.Modal = {};
            this.AutoClose.subscribe((value) => {
                if (value) {
                    setTimeout(() => { $("#" + this.Id).modal("hide"); }, 5000);
                }
            });
        }
    }
    exports.Modal = Modal;
});
//# sourceMappingURL=Modal.js.map